import React, { useState, useEffect } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import { Helmet } from "react-helmet";
import backend from "../../../../api";
import { url_encode } from "../../../../utils";
import { formatPrice } from "../../../../utils/formatPrice";
import ReactPaginate from "react-paginate";

const MemberPurchases = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const { user } = useSelector((state) => state.auth);

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchTransactions = async (page = 1) => {
    if (user) {
      if (pathname.includes(user?.user?.role)) {
        setLoading(true);
        backend
          .get(`/userwallet?user=${user.user._id}`, {
            params: {
              order_pos: true,
              page,
              limit: 5,
              populate: url_encode([
                {
                  path: "order_pos",
                  populate: [
                    { path: "merchant", populate: [{ path: "user" }] },
                  ],
                },
              ]),
            },
          })
          .then((response) => {
            setState(response.data.data || []);
            setTotalPages(response?.data?.totalPages || 1);
            setLoading(false);
          })
          .catch((err) => setLoading(false));
      } else {
        history.goBack();
      }
    }
  };

  useEffect(() => {
    fetchTransactions(page);
  }, [user, page]);

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setPage(selectedPage);
  };

  return (
    <>
      <Helmet>
        <title>eksplode! | My Purchases</title>
      </Helmet>
      <div className="dashboard">
        <div className="page-title">
          <h2>My Purchases</h2>
        </div>
        {loading ? (
          <div className="my-5 row justify-content-center">
            <ClipLoader color={"#000000"} loading={loading} size={60} />
          </div>
        ) : state?.length > 0 ? (
          state?.map((order) => {
            return (
              <div className="box-account box-info mt-3" key={order._id}>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="box">
                      <div className="box-title">
                        <h3>
                          <span>
                            Order ID &mdash;{" "}
                            <b>{order.order_pos.order_track_id}</b>
                          </span>
                          <br />
                          {/* <small className="text-muted">
                        Sales tax &mdash;{" "}
                        <b>
                          {order.order_pos.total_sales_tax &&
                            order.order_pos.total_sales_tax.toFixed(2)}
                        </b>
                      </small> */}
                          <br />
                        </h3>

                        <small>
                          Subtotal &mdash;{" "}
                          <b>
                            {formatPrice(order.order_pos.total_price &&
                              order.order_pos.total_price)}
                          </b>
                        </small>
                        <small>
                          Sales tax &mdash;{" "}
                          <b>
                            {formatPrice(order.order_pos.total_sales_tax &&
                              order.order_pos.total_sales_tax)}
                          </b>
                        </small>
                      </div>
                      <div className="box-content d-flex justify-content-between">
                        <a></a>

                        <small lassName="text-muted">
                          Transaction Date &mdash;{" "}
                          {new Date(order.transaction_date).toLocaleString()}
                        </small>
                      </div>
                      <div className="box-content">
                        {order && (
                          <small className="text-muted">
                            Retailer Name &mdash;
                            {order.order_pos.merchant.user.first_name +
                              " " +
                              order.order_pos.merchant.user.last_name}
                          </small>
                        )}

                        <br />

                        <small className="text-muted">
                          Program &mdash; {order.payment_source}
                        </small>
                      </div>

                      <div className="box-content"></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <h3>No Purchases</h3>
            </div>
          </div>
        )}
        {state?.length > 0 && (
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <ReactPaginate
                previousLabel={"<<"}
                nextLabel={">>"}
                breakLabel={"..."}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={page - 1}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MemberPurchases;
